// event manager (services/event-manager) events; their payloads are in EventData (types/webapp/event-data.ts)
export const enum AppEvent {
	ACCESS_TOKEN_REFRESHED = 'accessTokenRefreshed',
	AI_SUMMARY_EDITING_STATE_CHANGED = 'aiSummaryEditingStateChanged',
	ALL_POPUPS_CLOSED = 'allPopupsClosed',
	BLOCK_CONTENT_CLICKED = 'blockContentClicked',
	BLOCK_SELECT = 'blockSelect',
	CHART_RENDER_QUEUE_DONE = 'chartRenderServiceDone',
	CONNECT_INITIALIZATION_FINISHED = 'connectInitializationFinished',
	DATAMANAGER_SOURCES_CONTENT_CHANGED = 'datamanagerSourcesContentChanged',
	DATA_STORY_ELEMENT_OPEN_ADVANCED = 'dataStoryElementOpenAdvanced',
	DATA_STORY_INSERT_DIVIDER = 'insertDividerEvent',
	DATA_STORY_INSERT_TABLE = 'insertTableEvent',
	DATA_STORY_SET_INITIAL_STYLE = 'setInitialStyle',
	DESIGNER_BOARD_LOADED = 'designerBoardLoaded',
	DESIGNER_DATA_STORY_OVERRIDE = 'designerDataStoryOverride',
	DESIGNER_UNIBLOCK_DATA_SELECT_ADDED = 'designerUniblockDataSelectAdded',
	FORECAST_CHART_RENDERED = 'forecastChartRendered',
	GENIE_ANSWER_READY = 'genieAnswerReady',
	GENIE_PANEL_CONVERSATION_ENDED = 'geniePanelConversationEnded',
	FORECAST_DRAWER_SWITCH_TO_FORECAST_TAB = 'forecastDrawerSwitchToForecastTab',
	GOAL_INSIGHTS_GOAL_EDITED = 'insightsOnGoalEditEvent',
	METRIC_INSIGHTS_METRIC_EDITED = 'metricInsightsMetricEdited',
	METRIC_INSIGHTS_SWITCH_METRIC = 'metricInsightsSwitchMetric',
	ONBOARDING_COMPLETED = 'onboardingCompleted',
	OPEN_LEFT_SIDEBAR = 'openLeftSidebar',
	RECENT_ITEMS_VIEWED_CHANGED = 'recentItemsViewedChanged',
	REPORT_DATABOARDS_MDR_CHANGED = 'changeReportDataboardsMDR', // prefix, followed by the board fragment id
	REPORT_FRAGMENT_DELETE = 'reportFragmentDelete',
	REPORT_VIEWER_DESCRIPTION_EXPANDED_TOGGLED = 'reportViewerDescriptionExpandedToggled',
	REPORT_VIEWER_DESCRIPTION_OPEN_TOGGLED = 'reportViewerDescriptionOpenToggled',
	REPOSITION_FORECAST_HISTORY_TOOLTIP = 'repositionForecastHistoryTooltip',
	RERENDER_IMAGE_UPLOAD_DROP_COMPONENT = 'rerenderImageUploadDropComponent',
	RESEND_VERIFY = 'resendVerify',
	SOURCE_CONNECTED = 'sourceConnected',
	THEME_CHANGED = 'themeChanged',
	USER_VERIFIED = 'userVerified',
	VERIFICATION_CHANGED = 'verificationChanged',
	VIS_TEXT_EDITED = 'visTextEdited',
}
